import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCategory(value);
    if (value) {
      window.open(value, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20photography%20of%20curated%20fashion%20items%20including%20white%20leather%20sneakers%20cream%20cashmere%20hoodie%20gold%20minimalist%20watch%20retro%20sunglasses%20and%20linen%20accessories%20arranged%20artfully%20on%20warm%20terracotta%20fabric%20soft%20afternoon%20sunlight%20from%20top%20left%20editorial%20product%20photography%20with%20long%20shadows%20Scandinavian%20aesthetic%20warm%20neutral%20tones%20high%20end%20catalog%20quality%20harmonious%20composition%20with%20generous%20negative%20space&width=1600&height=900&seq=hero-bg-main-v2&orientation=landscape"
          alt="Curated fashion items flat lay - pandabuyspreadsheet collection"
          title="PandaBuy Spreadsheet - Curated Fashion Finds"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-full border-2 border-background-50/80 bg-secondary-300 flex items-center justify-center overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20portrait%20photography%20young%20adult%20face%20with%20short%20dark%20hair%20soft%20natural%20lighting%20neutral%20expression%20warm%20golden%20tones%20modern%20headshot%20style%20professional%20yet%20casual%20vibe&width=64&height=64&seq=avatar-hero-01-v2&orientation=squarish"
                    alt="User avatar 1"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-full border-2 border-background-50/80 bg-secondary-300 flex items-center justify-center overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20portrait%20photography%20young%20adult%20female%20face%20with%20wavy%20auburn%20hair%20soft%20natural%20lighting%20warm%20expression%20gentle%20smile%20modern%20headshot%20style%20professional%20yet%20friendly&width=64&height=64&seq=avatar-hero-02-v2&orientation=squarish"
                    alt="User avatar 2"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-full border-2 border-background-50/80 bg-secondary-300 flex items-center justify-center overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20portrait%20photography%20young%20adult%20male%20face%20with%20curly%20brown%20hair%20soft%20natural%20lighting%20confident%20expression%20modern%20headshot%20style%20professional%20yet%20relaxed%20diverse%20youth%20vibe&width=64&height=64&seq=avatar-hero-03-v2&orientation=squarish"
                    alt="User avatar 3"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-background-50/90 text-xs md:text-sm font-medium">10,000+ weekly active users</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              The #1 PandaBuy<br />
              <span className="font-light">Spreadsheet Hub for</span><br />
              Curated Finds &amp; Deals
            </h1>

            <p className="mt-5 text-background-50/80 text-sm md:text-base max-w-lg leading-relaxed">
              Discover the most updated <strong>pandabuyspreadsheet collections</strong> for sneakers, streetwear, luxury-inspired items, and budget finds — all in one place.
            </p>

            <div className="mt-6">
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="w-full max-w-md px-4 py-3 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl text-background-50 text-sm font-medium cursor-pointer focus:outline-none focus:border-background-50/40 transition-colors appearance-none"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='white' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 5.646a.5.5 0 0 1 .708 0L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 12px center',
                  paddingRight: '40px',
                }}
              >
                <option value="" className="text-foreground-950">Browse Categories</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url} className="text-foreground-950">
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-950 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                PandaBuy Sheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-transparent border border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex flex-col justify-center">
            <p className="text-background-50/70 text-lg md:text-xl leading-relaxed font-light max-w-md ml-auto">
              Updated daily with fresh <strong className="text-background-50 font-medium">pandabuyspreadsheet</strong> data. Hand-picked high-quality items only, with price and quality comparison built right in.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}